import { EventEmitter } from "events";
const eventEmitter = new EventEmitter();
export { eventEmitter as CustomEventEmitter };
